import { useState, useEffect } from 'react'
import { toast } from 'react-toastify';

export const useFetchAllProcessType = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [dataProcessType, setDataProcessType] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchAllProcessType, setLoadingFetchAllProcessType ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/legal-notarial/fetch-all-process-type`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchAllProcessType(true)
        fetchData()
            .then((resp) => {
                setDataProcessType(resp.rows)
                setLoadingFetchAllProcessType(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchAllProcessType(false)
            })
    }, [execute])

    return { dataProcessType, loadingFetchAllProcessType, executeFetch }

}

export const useFetchSpecificProcessType = ({marvarApi, dispatch, onLogout, Forms}) => {

    // 1. Para los datos recuperados de la BD
    // const [infoClient, setInfoClient] = useState([])
    const { FormScreen } = Forms
    const { formState, setFormState } = FormScreen
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchSpecificProcessType, setLoadingFetchSpecificProcessType ] = useState(false)

    // 3. Para setear parametros de búsqueda al fetch
    const [paramsToSearch, setParamsToSearch] = useState({idprocesstype: ''})

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            
            const response = await marvarApi.get(`/legal-notarial/fetch-specific-process-type/${paramsToSearch.idprocesstype}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idprocesstype > 0 ){
            setLoadingFetchSpecificProcessType(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { rows } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        idprocesstype: rows[0].idprocesstype,
                        name_process: rows[0].name_process,
                        category: rows[0].category,
                        type: rows[0].type
                    }))
                    setLoadingFetchSpecificProcessType(false)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchSpecificProcessType(false)
                })
        }
    }, [execute])

    return { loadingFetchSpecificProcessType, setParamsToSearch, executeFetch }

}